<template>
    <div class="lo router">
        <loPage>
            <loAside ref="loAside">
                <mdCaption
                    :caption="$t('site.noun.productcategory')"
                ></mdCaption>
                <mdNav
                    v-if="list.length"
                    :data="navTree"

                    @sendEvent="receiveEvent"
                ></mdNav>
                <div
                    v-else
                    class="g mask-box-side"
                >
                    <transition name="fade">
                        <mdLoading></mdLoading>
                    </transition>
                </div>
            </loAside>
            <loSection>
                <template v-if="productSN">
                    <loHeading
                        :caption="$t('page.product.caption.productinfo')"
                    ></loHeading>
                    <loArticle>
                        <mdProductInfo
                            :sn="productSN"

                            @sendEvent="receiveEvent"
                        ></mdProductInfo>
                        <mdNavToggle></mdNavToggle>
                    </loArticle>
                </template>
                <template v-else>
                    <loHeading
                        :caption="productCaption"
                    ></loHeading>
                    <loArticle>
                        <gProductList
                            v-if="productListInit"
                            :list="list"
                            :setLength="20"
                            :selector="[12, 24, 48, 96]"
                            :pageSet="page"
                            :action="chagePage"

                            @sendEvent="receiveEvent"
                        ></gProductList>
                        <div
                            v-else
                            class="g mask-box-center"
                        >
                            <transition name="fade">
                                <mdLoading></mdLoading>
                            </transition>
                        </div>
                        <mdNavToggle></mdNavToggle>
                    </loArticle>
                </template>
            </loSection>
        </loPage>
    </div>
</template>

<script>
    import loPage from '@/components/loPage'
    import loHeading from '@/components/loHeading'
    import loSection from '@/components/loSection'
    import loArticle from '@/components/loArticle'
    import loAside from '@/components/loAside'
    import mdNav from '@/components/mdNav'
    import mdCaption from '@/components/mdCaption'
    import mdProductInfo from '@/components/mdProductInfo'
    import mdLoading from '@/components/mdLoading'
    import mdNavToggle from '@/components/mdNavToggle'
    import gProductList from '@/components/gProductList'
    import cpBtn from '@/components/cpBtn'

    import { mapState, mapMutations } from 'vuex'

    export default {
        components: {
            loPage,
            loHeading,
            loSection,
            loArticle,
            loAside,
            mdNav,
            mdCaption,
            mdProductInfo,
            mdLoading,
            mdNavToggle,
            gProductList,
            cpBtn,
        },
        data: function(){

            return {
                list: [],
                nav: [],
                openSN: '',
                showAside: true,
            }
        },
        watch: {
            productClass: {
                handler: function(){
                    this.initProductClass();
                }
            },
            productList: {
                handler: function(){
                    this.init();
                }
            },
        },
        computed: {
            ...mapState([
                'user',
                'langID',
                'token',
                'productClass',
                'productList',
                'productListInit',
            ]),
            query: function(){
                return this.$route.query || {}
            },
            productClassSN: function(){
                return this.query.class;
            },
            productM: function(){
                return this.query.product;
            },
            productSN: function(){
                return this.query.item;
            },
            page: function(){
                let _result = this.query.page || 1;

                return parseInt(_result);
            },
            productCaption: function(){
                let $navSet = this.navSet,
                    $data = $navSet.find(item => {
                        return item.active === true;
                    }),
                    $parent = $navSet.find(item => {
                        return item.sn === $data.parent
                    })

                let _result = '';

                if( $data && $parent ) {

                    if( $data.product && $data.product === 'all'){
                        _result = $parent.caption;
                    }else{
                        _result = $parent.caption +' \\ '+ $data.caption
                    }
                }

                return _result; 
            },
            navSet: function(){
                let $nav = this.nav,
                    $result = []

                let _openSN = this.openSN,
                    _activeSN = this.productClassSN;

                if( this.productM ) {
                    _activeSN = _activeSN +'-'+ this.productM;
                }

                $nav.forEach(item => {
                    
                    $result.push({
                        sn: item.sn,
                        caption: item.caption,
                        product: item.product,
                        active: item.sn === _activeSN,
                        open: item.sn === _openSN,
                        items: item.items,
                        parent: item.parent,
                        subs: [],
                    });
                });

                return $result;
            },
            navTree: function(){
                let $navSet = this.navSet,
                    $result = []

                $navSet.forEach(item => {
                    let _parent = item.parent;

                    if( _parent ) {
                        let $target = $navSet.find(navSet => navSet.sn === _parent);

                        $target.subs.push(item);

                    }else {
                        $result.push(item);
                    }
                });

                return $result
            },
        },
        methods: {
            ...mapMutations([
                'catchError',
            ]),
            chagePage: function(page){
                this.$router.push('/system/productList?class='+ this.productClassSN +'&product='+ this.productM +'&page='+ page);
            },
            setShow: function(){
                let $list = this.list,
                    _class = this.productClassSN,
                    _product = this.productM;
                
                $list.forEach(item => {
                    let _show = false;

                    if( _class && _product ) {
                        /**
                         * 2023/12/21 增加副牌料相關顯示(product_type: 0:主原料,1:副牌料,2:兩者皆是) 
                         * https://www.notion.so/PE-8fa460857a884a30b8c06b230b6b6758
                         * 
                         * 2024/10/30 因PE報價單修改了產品中類，要求將側邊欄的分類改顯示產品大類來分類
                         */
                   
                        if( item.class.includes(_class) && (_product === 'all' || ((item.product_codiv === '18'?item.product_b === _product:item.product_m === _product )&& (item.product_type == 0 ||  item.product_type == 2)) || (_product === 'offGrade' && (item.product_type == 1 ||  item.product_type == 2)) ) ) {
                            _show = true;
                        }

                    }else if( _class ) {

                        if( item.class.includes(_class) ) {
                            _show = true;
                        }
                    }else {
                        _show = true;
                    }

                    item.show = _show;
                });
            },
            clickNav: function(opt){
                let _sn = opt.sn,
                    _parent = opt.parent,
                    _product = opt.product;

                if( _parent ) {
                    this.$router.push('/system/productList?class='+ _parent +'&product='+ _product);
                    
                    this.$refs.loAside.changeState();
                }else {

                    if( this.openSN === _sn ) {
                        this.$set(this, 'openSN', '')
                    }else {
                        this.$set(this, 'openSN', _sn)
                    }
                }

                this.setShow();
            },
            clickProduct: function(opt){
                let _productClass = this.productClassSN,
                    _productM = this.productM || 'all';

                this.$router.push('/system/productList?class='+ _productClass +'&product='+ _productM +'&item='+ opt.sn);
            },
            favorite: function(opt){
                this.$emit('sendEvent', 'favorite', opt);
            },
            contact: function(sn){
                this.$emit('sendEvent', 'contact', sn);
            },
            initProductClass: function(res){
                let $data = this.productClass,
                    $result = []

                $data.forEach(item => {

                    $result.push({
                        sn: item.class,
                        caption: item.title,
                        product: null,
                        parent: null,
                    });
                });

                $data.forEach(item => {

                    $result.push({
                        sn: item.class +'-all',
                        caption: this.$t('page.productlist.caption.all'),
                        product: 'all',
                        parent: item.class,
                    });
                })

                this.$set(this, 'nav', $result);
                
                this.initProductData();
            },
            initProductData: function(res){
                let $data = this.$okaTool.copy(this.productList) || [],
                    $result = []
                
                let $nav = this.nav;

                $data.sort((a,b) => a.product_type > b.product_type? 1:-1);

                $data.forEach(item => {

                    if( item.is_on_market ) {

                        let $node = {
                                node: item,
                                class: item.class,
                                product_codiv: item.product_codiv, //20241030_因PE需求增加產品所屬事業部
                                product_b: item.product_b,
                                product_m: item.product_m,
                                product_s: item.product_s,
                                product_type: item.product_type,
                                alias: item.alias,
                                sn: item.product_sn,
                                label: item.label || '',
                                caption: item.product_s,
                                essay: item.product_b +'-'+ item.product_m,
                                image: item.imageurl,
                                favorite: item.is_favorite,
                                show: false,
                            }

                        $result.push($node);

                        item.class.forEach(_class => {
                            if(item.product_codiv === '18'){ //20241030_因PE需求增加特殊判斷，將分類改為產品大類
                                let _classSN = _class +'-'+ item.product_b,
                                    $target = $nav.find(nav => nav.sn === _classSN);

                                if( !$target ) {

                                    $nav.push({
                                        sn: _class +'-'+ item.product_b,
                                        caption: item.product_b,
                                        product: item.product_b,
                                        parent: _class,
                                    });
                                }

                            }else {
                                let _classSN = _class +'-'+ item.product_m,
                                    $target = $nav.find(nav => nav.sn === _classSN);

                                if( !$target ) {

                                    $nav.push({
                                        sn: _class +'-'+ item.product_m,
                                        caption: item.product_m,
                                        product: item.product_m,
                                        parent: _class,
                                    });
                                }
                            }
                            //有副牌料的就塞副牌料
                            if( item.product_type !== 0 ) {
                                let _class = item.class +'-offGrade';

                                if( !$nav.find(nav => nav.sn === _class) ) {

                                    $nav.push({
                                        sn: item.class +'-offGrade',
                                        caption: '副牌料',
                                        product: 'offGrade',
                                        parent: item.class[0],
                                        subs: [],
                                    });
                                }
                            }
                        });
                    }
                });
            
                this.$set(this, 'list', $result);
            },
            init: async function(){
                this.initProductClass();
                this.setShow();
            }
        },
        created: function(){
            let $query = this.$route.query || {},
                _class = $query.class || '';

            if( _class ) {
                this.$set(this, 'openSN', _class);
            }

            this.init();
        }
    }
</script>

<style scoped lang="scss">

    .fade-enter-active, .fade-leave-active {
        transition: 250ms ease;
    }

    .fade-enter {
        opacity: 0;
    }

    .fade-enter-to {
        opacity: 1;
    }

    .fade-leave {
        opacity: 1;
    }

    .fade-leave-to {
        opacity: 0;
    }

    .g.mask-box-side {

        &::v-deep {

            .md.loading {
                height: calc(100vh - 160px);
            }
        }
    }

    .g.mask-box-center {

        &::v-deep {

            .md.loading {
                height: calc(100vh - 150px);
            }
        }
    }
</style>
